"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Calendar = _interopRequireDefault(require("../Calendar/Calendar"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _FormInput = _interopRequireDefault(require("../Forms/FormInput"));

var _FormMessage = _interopRequireDefault(require("../Forms/_FormMessage"));

var _InputGroup = _interopRequireDefault(require("../InputGroup/InputGroup"));

var _dateUtils = require("../utils/dateUtils");

var _moment = _interopRequireDefault(require("moment"));

var _Popover = _interopRequireDefault(require("../Popover/Popover"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _validDateLookup = require("./_validDateLookup");

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _constants = require("../utils/constants");

var _react = _interopRequireWildcard(require("react"));

var _bar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/bar.css") : void 0);

var _dialog = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/dialog.css") : void 0);

var _inputGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/input-group.css") : void 0);

var _list = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/list.css") : void 0);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; (0, _forEach.default)(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source))).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _list.default), _inputGroup.default), _dialog.default), _bar.default));
var ISO_DATE_FORMAT = 'YYYY-MM-DD';
var dateRangeSeparator = ' - ';
/** A **DatePicker** is an opinionated composition of the **Input Group**, **Popover**
 * and **Calendar** components to accomplish the UI pattern for picking a date. */

var DatePicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DatePicker, _Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this$props3;

    var _this;

    (0, _classCallCheck2.default)(this, DatePicker);
    _this = _super.call(this, props);

    _this.toISOFormat = function (dateStr) {
      if (!dateStr || !(dateStr === null || dateStr === void 0 ? void 0 : (0, _trim.default)(dateStr).call(dateStr).length)) return '';
      return (0, _moment.default)(dateStr, _this.resolveFormat()).format(ISO_DATE_FORMAT);
    };

    _this.getFormattedDateStr = function (date) {
      if (date) {
        var momentDateObj = _this.getMomentDateObj(date);

        if (momentDateObj && momentDateObj.isValid()) {
          return momentDateObj.format(_this.resolveFormat());
        } else {
          return '';
        }
      }

      return date;
    };

    _this.resolveFormat = function () {
      var _this$props = _this.props,
          dateFormat = _this$props.dateFormat,
          locale = _this$props.locale;

      if (dateFormat) {
        return dateFormat;
      } else if (locale) {
        var localeData = _moment.default.localeData(locale);

        return localeData.longDateFormat('L');
      }

      return ISO_DATE_FORMAT;
    };

    _this.getFormattedDateRangeStr = function (dates) {
      var str = _this.getFormattedDateStr(dates[0]);

      if (!!dates[1]) {
        str += dateRangeSeparator + _this.getFormattedDateStr(dates[1]);
      }

      return str;
    };

    _this.getValidFormats = function () {
      var format = _this.resolveFormat();

      return _validDateLookup.validDateLookup[format] ? _validDateLookup.validDateLookup[format] : format;
    };

    _this.modifyDate = function (e) {
      _this.setState({
        formattedDate: e.target.value
      });
    };

    _this.handleNewDefault = function () {
      var defaultValue = _this.props.defaultValue;

      _this.setState({
        formattedDate: defaultValue
      }, function () {
        _this.validateDates();
      });
    };

    _this.handleOnChange = function (e) {
      var _e$target;

      e.stopPropagation();

      _this.setState({
        formattedDate: e.target.value,
        isoFormattedDate: _this.toISOFormat((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value)
      }, function () {
        _this.props.onChange(_this.getCallbackData(), 'inputChange');
      });
    };

    _this.sendUpdate = function (e) {
      if (e.key === 'Enter') {
        _this.validateDates();
      }
    };

    _this.isDateValid = function (date) {
      return date.isValid() && (0, _dateUtils.isEnabledDate)(date, _this.props);
    };

    _this.getCallbackData = function () {
      return {
        date: _this.state.selectedDate,
        formattedDate: _this.state.formattedDate,
        isoFormattedDate: _this.state.isoFormattedDate,
        startAndEndDates: _this.state.startAndEndDates
      };
    };

    _this.executeCallback = function (callbackFunction, reason) {
      callbackFunction && typeof callbackFunction === 'function' && (reason ? callbackFunction(_this.getCallbackData(), reason) : callbackFunction(_this.getCallbackData()));
    };

    _this.validateDates = function (postValidationCallback) {
      var formattedDate = _this.state.formattedDate;

      if (!formattedDate || !(formattedDate === null || formattedDate === void 0 ? void 0 : (0, _trim.default)(formattedDate).call(formattedDate).length)) {
        _this.resetState(postValidationCallback);
      } else if (_this.props.enableRangeSelection) {
        var dateRange = formattedDate.split(dateRangeSeparator);

        var firstDate = _this.getMomentDateObj(dateRange[0]);

        var secondDate = _this.getMomentDateObj(dateRange[1]);

        if (_this.isDateValid(firstDate) && _this.isDateValid(secondDate)) {
          var arrSelected = [];
          firstDate.isAfter(secondDate) ? arrSelected = [secondDate, firstDate] : arrSelected = [firstDate, secondDate];

          var newFormattedDateRangeStr = _this.getFormattedDateRangeStr(arrSelected);

          _this.setState({
            formattedDate: newFormattedDateRangeStr,
            isoFormatDate: arrSelected[0].format(ISO_DATE_FORMAT) + dateRangeSeparator + arrSelected[1].format(ISO_DATE_FORMAT),
            selectedDate: null,
            startAndEndDates: arrSelected
          }, function () {
            if (formattedDate !== newFormattedDateRangeStr) {
              _this.executeCallback(_this.props.onChange, 'autoFormatDateRange');
            }

            _this.executeCallback(postValidationCallback);
          });
        } else {
          _this.resetState(postValidationCallback);
        }
      } else {
        var newDate = _this.getMomentDateObj(formattedDate);

        if (_this.isDateValid(newDate)) {
          var newFormattedDateStr = _this.getFormattedDateStr(formattedDate);

          _this.setState({
            selectedDate: newDate,
            formattedDate: newFormattedDateStr,
            isoFormattedDate: newDate.format(ISO_DATE_FORMAT),
            startAndEndDates: []
          }, function () {
            if (formattedDate !== newFormattedDateStr) {
              _this.executeCallback(_this.props.onChange, 'autoFormat');
            }

            _this.executeCallback(postValidationCallback);
          });
        } else {
          _this.resetState(postValidationCallback);
        }
      }
    };

    _this.resetState = function (postValidationCallback) {
      var formattedDate = _this.state.formattedDate;

      _this.setState({
        formattedDate: '',
        isoFormattedDate: '',
        selectedDate: null,
        startAndEndDates: []
      }, function () {
        if (formattedDate !== '') {
          _this.executeCallback(_this.props.onChange, 'invalidInput');
        }

        _this.executeCallback(postValidationCallback);
      });
    };

    _this.handleClickButton = function () {
      _this.setState({
        isExpanded: !_this.state.isExpanded
      });

      var popover = _this.popoverRef && _this.popoverRef.current;
      popover && popover.triggerBody();
    };

    _this.handleOutsideClickAndEscape = function () {
      _this.setState({
        isExpanded: false
      });
    };

    _this.handleFocus = function () {
      _this.props.onInputFocus(_this.getCallbackData());
    };

    _this.updateDate = function (date, forceStayOpen, reason) {
      var closeCalendar = false;
      var formattedDate = _this.state.formattedDate;

      if (_this.props.enableRangeSelection) {
        var isoFormatDateRange = date[0].format(ISO_DATE_FORMAT);

        if (!!date[1]) {
          isoFormatDateRange += dateRangeSeparator + date[1].format(ISO_DATE_FORMAT);
          closeCalendar = true;
        }

        var newFormattedDateRangeStr = _this.getFormattedDateRangeStr(date);

        _this.setState({
          formattedDate: newFormattedDateRangeStr,
          isoFormattedDate: isoFormatDateRange,
          selectedDate: null,
          startAndEndDates: date
        }, function () {
          if (formattedDate !== newFormattedDateRangeStr) {
            _this.props.onChange(_this.getCallbackData(), reason);
          }
        });
      } else {
        closeCalendar = true;

        var newFormattedDate = _this.getFormattedDateStr(date);

        _this.setState({
          formattedDate: newFormattedDate,
          isoFormattedDate: _this.toISOFormat(newFormattedDate),
          selectedDate: date,
          startAndEndDates: []
        }, function () {
          if (formattedDate !== newFormattedDate) {
            _this.props.onChange(_this.getCallbackData(), reason);
          }
        });
      }

      if (!forceStayOpen && closeCalendar) {
        var popover = _this.popoverRef && _this.popoverRef.current;
        popover && popover.handleEscapeKey();

        _this.setState({
          isExpanded: false
        }, function () {
          _this.props.onDatePickerClose(_this.getCallbackData());
        });
      }
    };

    _this.handleBlur = function () {
      _this.validateDates(_this.props.onInputBlur);
    };

    _this.showTodayHeader = function () {
      var _this$props$todayActi = _this.props.todayAction,
          todayLabel = _this$props$todayActi.label,
          todayType = _this$props$todayActi.type;
      return todayType === 'navigate' && todayLabel && typeof todayLabel === 'string' && (0, _trim.default)(todayLabel).call(todayLabel).length > 0;
    };

    _this.showTodayFooter = function () {
      var _this$props2 = _this.props,
          enableRangeSelection = _this$props2.enableRangeSelection,
          _this$props2$todayAct = _this$props2.todayAction,
          todayLabel = _this$props2$todayAct.label,
          todayType = _this$props2$todayAct.type;
      return todayType === 'select' && !enableRangeSelection && (0, _dateUtils.isEnabledDate)((0, _moment.default)(), _this.props) && todayLabel && typeof todayLabel === 'string' && (0, _trim.default)(todayLabel).call(todayLabel).length > 0;
    };

    _this.setTodayDate = function () {
      _this.updateDate((0, _moment.default)().locale(_this.props.locale), false, 'todaySelected');
    };

    _this.state = {
      formattedDate: ((_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.defaultValue) || '',
      isExpanded: false
    };
    _this.calendarRef = /*#__PURE__*/_react.default.createRef();
    _this.popoverRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(DatePicker, [{
    key: "getMomentDateObj",

    /**
     * Function to create a Moment.js date object from given dateString.
     * It will try to use multiple similar formats, defined in validDateLookup, to
     * parse the given dateString and props.locale
     * @param  {String} dateString to parse.
     * @returns {Object} Moment.js date object.
     */
    value: function getMomentDateObj(dateString) {
      return (0, _moment.default)(dateString, this.getValidFormats(), this.props.locale, true);
    }
    /**
     * Get the different date formats allowed for user input.
     * These formats are based on props.dateFormat
     * If no entry for props.dateFormat found in validDateLookup,
     * it returns the configured format as string.
     *
     * @returns {Array} collection of date formats allowed for input.
     */

  }, {
    key: "getPlaceHolder",
    value: function getPlaceHolder() {
      var placeholderDateFormat = this.resolveFormat();

      if (this.props.enableRangeSelection) {
        return placeholderDateFormat + dateRangeSeparator + placeholderDateFormat;
      }

      return placeholderDateFormat;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateDates();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.defaultValue !== this.props.defaultValue) {
        this.handleNewDefault();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames2,
          _validationState$text,
          _this2 = this;

      var _this$props4 = this.props,
          addonProps = _this$props4.addonProps,
          blockedDates = _this$props4.blockedDates,
          buttonLabel = _this$props4.buttonLabel,
          buttonProps = _this$props4.buttonProps,
          calendarProps = _this$props4.calendarProps,
          compact = _this$props4.compact,
          cssNamespace = _this$props4.cssNamespace,
          dateFormat = _this$props4.dateFormat,
          disabled = _this$props4.disabled,
          disableAfterDate = _this$props4.disableAfterDate,
          disableBeforeDate = _this$props4.disableBeforeDate,
          disabledDates = _this$props4.disabledDates,
          disableFutureDates = _this$props4.disableFutureDates,
          disablePastDates = _this$props4.disablePastDates,
          disableWeekday = _this$props4.disableWeekday,
          disableWeekends = _this$props4.disableWeekends,
          enableRangeSelection = _this$props4.enableRangeSelection,
          footerButtonProps = _this$props4.footerButtonProps,
          footerClasses = _this$props4.footerClasses,
          inputProps = _this$props4.inputProps,
          inputGroupProps = _this$props4.inputGroupProps,
          locale = _this$props4.locale,
          localizedText = _this$props4.localizedText,
          onInputBlur = _this$props4.onInputBlur,
          onInputFocus = _this$props4.onInputFocus,
          onDatePickerClose = _this$props4.onDatePickerClose,
          openToDate = _this$props4.openToDate,
          popoverProps = _this$props4.popoverProps,
          readOnly = _this$props4.readOnly,
          showToday = _this$props4.showToday,
          specialDays = _this$props4.specialDays,
          todayAction = _this$props4.todayAction,
          validationOverlayProps = _this$props4.validationOverlayProps,
          validationState = _this$props4.validationState,
          weekdayStart = _this$props4.weekdayStart,
          modalManager = _this$props4.modalManager,
          props = (0, _objectWithoutProperties2.default)(_this$props4, ["addonProps", "blockedDates", "buttonLabel", "buttonProps", "calendarProps", "compact", "cssNamespace", "dateFormat", "disabled", "disableAfterDate", "disableBeforeDate", "disabledDates", "disableFutureDates", "disablePastDates", "disableWeekday", "disableWeekends", "enableRangeSelection", "footerButtonProps", "footerClasses", "inputProps", "inputGroupProps", "locale", "localizedText", "onInputBlur", "onInputFocus", "onDatePickerClose", "openToDate", "popoverProps", "readOnly", "showToday", "specialDays", "todayAction", "validationOverlayProps", "validationState", "weekdayStart", "modalManager"]);
      var inputGroupClass = classnames("".concat(cssNamespace, "-input-group--control"), (0, _defineProperty3.default)({}, "is-".concat(validationState === null || validationState === void 0 ? void 0 : validationState.state), validationState === null || validationState === void 0 ? void 0 : validationState.state), inputGroupProps === null || inputGroupProps === void 0 ? void 0 : inputGroupProps.className);
      var datepickerFooterClassName = classnames("".concat(cssNamespace, "-dialog__footer"), "".concat(cssNamespace, "-bar"), "".concat(cssNamespace, "-bar--footer"), (_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, "".concat(cssNamespace, "-bar--cozy"), !compact), (0, _defineProperty3.default)(_classnames2, "".concat(cssNamespace, "-bar--compact"), compact), _classnames2), footerClasses);
      var footerButtonClassnames = classnames("".concat(cssNamespace, "-dialog__decisive-button"), footerButtonProps === null || footerButtonProps === void 0 ? void 0 : footerButtonProps.className);

      var inputGroup = /*#__PURE__*/_react.default.createElement(_InputGroup.default, (0, _extends2.default)({}, inputGroupProps, {
        "aria-expanded": this.state.isExpanded,
        "aria-haspopup": "true",
        className: inputGroupClass,
        compact: compact,
        disabled: disabled,
        validationOverlayProps: validationOverlayProps,
        validationState: this.state.isExpanded ? null : validationState
      }), /*#__PURE__*/_react.default.createElement(_FormInput.default, (0, _extends2.default)({}, inputProps, {
        onBlur: this.handleBlur,
        onChange: this.handleOnChange,
        onFocus: this.handleFocus,
        onKeyPress: this.sendUpdate,
        placeholder: this.getPlaceHolder(dateFormat),
        readOnly: readOnly,
        value: this.state.formattedDate
      })), !readOnly && /*#__PURE__*/_react.default.createElement(_InputGroup.default.Addon, (0, _extends2.default)({}, addonProps, {
        isButton: true
      }), /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, buttonProps, {
        "aria-label": buttonLabel,
        disabled: disabled,
        glyph: "appointment-2",
        onClick: this.handleClickButton,
        option: "transparent"
      }))));

      var calendarClasses = classnames((0, _defineProperty3.default)({}, "".concat(cssNamespace, "-list--has-message"), validationState === null || validationState === void 0 ? void 0 : validationState.state), calendarProps === null || calendarProps === void 0 ? void 0 : calendarProps.className);
      return /*#__PURE__*/_react.default.createElement("div", props, /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({}, popoverProps, {
        body: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (validationState === null || validationState === void 0 ? void 0 : (_validationState$text = validationState.text) === null || _validationState$text === void 0 ? void 0 : _validationState$text.length) > 0 && /*#__PURE__*/_react.default.createElement(_FormMessage.default, (0, _extends2.default)({}, validationOverlayProps === null || validationOverlayProps === void 0 ? void 0 : validationOverlayProps.formMessageProps, {
          forPopoverList: true,
          type: validationState.state
        }), validationState.text), /*#__PURE__*/_react.default.createElement(_Calendar.default, (0, _extends2.default)({}, calendarProps, {
          blockedDates: blockedDates,
          className: calendarClasses,
          compact: compact,
          customDate: enableRangeSelection ? this.state.startAndEndDates : this.state.selectedDate,
          disableAfterDate: disableAfterDate,
          disableBeforeDate: disableBeforeDate,
          disableFutureDates: disableFutureDates,
          disablePastDates: disablePastDates,
          disableWeekday: disableWeekday,
          disableWeekends: disableWeekends,
          disabledDates: disabledDates,
          enableRangeSelection: enableRangeSelection,
          focusOnInit: true,
          locale: locale,
          localizedText: _objectSpread(_objectSpread({}, localizedText), {}, {
            todayLabel: todayAction.label
          }),
          onChange: function onChange(date, todayNavigated) {
            _this2.updateDate(date, todayNavigated, todayNavigated ? 'todayNavigated' : 'calendarDateClicked');
          },
          openToDate: openToDate,
          ref: this.calendarRef,
          showToday: this.showTodayHeader(),
          specialDays: specialDays,
          weekdayStart: weekdayStart
        })), this.showTodayFooter() && /*#__PURE__*/_react.default.createElement("div", {
          className: datepickerFooterClassName
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: classnames("".concat(cssNamespace, "-bar__right"))
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: classnames("".concat(cssNamespace, "-bar__element"))
        }, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, footerButtonProps, {
          className: footerButtonClassnames,
          compact: compact,
          onClick: this.setTodayDate
        }), todayAction.label))))),
        control: inputGroup,
        disableKeyPressHandler: true,
        disableTriggerOnClick: true,
        disabled: disabled || readOnly,
        modalManager: modalManager,
        noArrow: true,
        onClickOutside: this.handleOutsideClickAndEscape,
        onEscapeKey: this.handleOutsideClickAndEscape,
        ref: this.popoverRef
      })));
    }
  }]);
  return DatePicker;
}(_react.Component);

DatePicker.displayName = 'DatePicker';
process.env.NODE_ENV !== "production" ? DatePicker.propTypes = _objectSpread(_objectSpread({}, _Calendar.default.PropTypes), {}, {
  /** Additional props to be spread to the input group addon button container i.e. `<InputGroup.Addon {...addonProps} >` */
  addonProps: _propTypes.default.object,

  /** aria-label for datepicker button */
  buttonLabel: _propTypes.default.string,

  /** Additional props to be spread to the `<button>` element */
  buttonProps: _propTypes.default.object,
  calendarProps: _propTypes.default.shape({
    monthListProps: _propTypes.default.object,
    tableBodyProps: _propTypes.default.object,
    tableHeaderProps: _propTypes.default.object,
    tableProps: _propTypes.default.object,
    yearListProps: _propTypes.default.object
  }),

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Format to use for displaying the inputted or selected date. E.g. "YYYY.M.D", "DD-MM-YYYY", "MM/DD/YYYY" etc.
   * This overrides the date format derived from any set locale. */
  dateFormat: _propTypes.default.string,

  /**
   * Default value to be shown in the Datepicker
   * for example, `defaultValue='12/04/1993'`
   * or when range selection is enabled `defaultValue='12/04/1993 - 12/30/1992'` (will auto sort chronologically)
   * */
  defaultValue: _propTypes.default.string,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Set to **true** to enable the selection of a date range (begin and end) */
  enableRangeSelection: _propTypes.default.bool,

  /** Additional props to to apply to calendar footer button*/
  footerButtonProps: _propTypes.default.object,

  /** Classnames to apply to calendar footer that will contain the 'Today' action */
  footerClasses: _propTypes.default.string,

  /** Additional props to be spread to the `InputGroup` component */
  inputGroupProps: _propTypes.default.object,

  /** Additional props to be spread to the `<input>` element */
  inputProps: _propTypes.default.object,

  /** Language code to set the locale */
  locale: _propTypes.default.string,

  /** If DatePicker is to be rendered in a modal, the parent modal manager can be passed as a prop */
  modalManager: _propTypes.default.object,

  /** Additional props to be spread to the Popover component */
  popoverProps: _propTypes.default.object,

  /** Set to **true** to mark component as readonly */
  readOnly: _propTypes.default.bool,

  /** Object with special dates and special date types in shape of `{'YYYYMMDD': type}`. Type must be a number between 1-20 */
  specialDays: _propTypes.default.object,

  /** Config object for DatePicker's today action button.
   *  For example, ```todayAction={type: 'select', label: 'Today'}```
   *
   * **todayAction.type** is a string indicating the type of today button
   *
   * - `'none'` today button won't be shown
   * - `'select'` today button as footer action that selects today's date and closes datepicker
   * - `'navigate'` today button as header action that navigates (i.e. sets focus) to today's date
   *
   * **todayAction.label** is a localized string label for the today action button.
   *
   * The button will only be rendered if:
   *
   * - `todayAction.type` is `'select'` or `'navigate'`
   * - AND `todayAction.label` is a valid non-empty string
  */
  todayAction: _propTypes.default.shape({
    type: _propTypes.default.oneOf(_constants.DATEPICKER_TODAY_ACTIONS_TYPES),
    label: (0, _reactRequiredIf.default)(_propTypes.default.string, function (todayAction) {
      var _todayAction$type;

      var todayActionType = todayAction === null || todayAction === void 0 ? void 0 : (_todayAction$type = todayAction.type) === null || _todayAction$type === void 0 ? void 0 : (0, _trim.default)(_todayAction$type).call(_todayAction$type);
      return todayActionType === 'select' || todayActionType === 'navigate';
    })
  }),

  /** Additional props to be spread to the ValidationOverlay */
  validationOverlayProps: _propTypes.default.shape({
    /** Additional classes to apply to validation popover's outermost `<div>` element  */
    className: _propTypes.default.string,

    /** Additional props to be spread to the ValdiationOverlay's FormMessage component */
    formMessageProps: _propTypes.default.object,

    /** Additional classes to apply to validation popover's popper child `<div>` wrapping the provided children  */
    innerRefClassName: _propTypes.default.string,

    /** Additional classes to apply to validation popover's popper `<div>` element  */
    popperClassName: _propTypes.default.string,

    /** CSS class(es) to add to the ValidationOverlay's reference `<div>` element */
    referenceClassName: _propTypes.default.string,

    /** Additional props to be spread to the popover's outermost `<div>` element */
    wrapperProps: _propTypes.default.object
  }),

  /** An object identifying a validation message.  The object will include properties for `state` and `text`;
   * _e.g._, \`{ state: \'warning\', text: \'This is your last warning\' }\` */
  validationState: _propTypes.default.shape({
    /** State of validation: 'error', 'warning', 'information', 'success' */
    state: _propTypes.default.oneOf(_constants.FORM_MESSAGE_TYPES),

    /** Text of the validation message */
    text: _propTypes.default.string
  }),

  /** Callback function; triggered when the selected date changes.
   * There can be many reasons for a date change.
   * The reason is available as a String and could be one of `todaySelected`, `todayNavigated`, `calendarDateClicked`,
   * `inputChange`, `autoFormat` or `invalidInput`
   *
   * @param {Object} data - data.date is the selected date object; data.formattedDate is the formatted date string;
   * data.isoFormattedDate is the formatted date string in ISO-8601 format i.e. YYYY-MM-DD; data.startAndEndDates is an
   * array of date objects containing the start and end date if enableRangeSelection is true.
   * @param {string} reason - what caused the selection to change
   * @returns {void}
   */
  onChange: _propTypes.default.func,

  /** Callback function; triggered when datepicker popover closes after date selection.
   *
   * @param {Object} data - data.date is the selected date object; data.formattedDate is the formatted date string;
   * data.isoFormattedDate is the formatted date string in ISO-8601 format i.e. YYYY-MM-DD; data.startAndEndDates is an
   * array of date objects containing the start and end date if enableRangeSelection is true.
   * @returns {void}
   */
  onDatePickerClose: _propTypes.default.func,

  /** Callback function; triggered when text input field loses focus.
    * Input value is validated before calling onInputBlur.
    * If input field value can be formatted to a valid date object then this is used as the data, else field is reset.
    *
    * @param {Object} data - data.date is the selected date object; data.formattedDate is the formatted date string;
    * data.isoFormattedDate is the formatted date string in ISO-8601 format i.e. YYYY-MM-DD; data.startAndEndDates is an
    * array of date objects containing the start and end date if enableRangeSelection is true.
    * @returns {void}
   */
  onInputBlur: _propTypes.default.func,

  /** Callback function; triggered when datepicker input is focused.
   *
   * @param {Object|SyntheticEvent} data - data.date is the selected date object; data.formattedDate is the formatted date string;
   * data.isoFormattedDate is the formatted date string in ISO-8601 format i.e. YYYY-MM-DD; data.startAndEndDates is an
   * array of date objects containing the start and end date if enableRangeSelection is true.
   * @returns {void}
   */
  onInputFocus: _propTypes.default.func
}) : void 0;
DatePicker.defaultProps = {
  buttonLabel: 'Choose date',
  defaultValue: '',
  dateFormat: null,
  locale: 'en',
  localizedText: _Calendar.default.defaultProps.localizedText,
  todayAction: {
    type: 'none'
  },
  onInputBlur: function onInputBlur() {},
  onChange: function onChange() {},
  onDatePickerClose: function onDatePickerClose() {},
  onInputFocus: function onInputFocus() {}
};

var _default = (0, _withStyles.default)(DatePicker);

exports.default = _default;